/* ============================================
   DINKYDOO NAV DRAWER — JavaScript v2
   Fix: focus trap correctly released on close
   No dependencies. Vanilla JS only.
   ============================================ */

(function () {
  'use strict';

  // ─── State ───────────────────────────────────
  let currentLevel = 1;
  let lastTrigger = null;

  // ─── Elements ────────────────────────────────
  const drawer      = document.getElementById('nav-drawer');
  const overlay     = document.getElementById('nav-drawer-overlay');
  const panelL1     = document.getElementById('nav-drawer-panel-l1');
  const panelL2     = document.getElementById('nav-drawer-panel-l2');
  const headerTitle = document.getElementById('nav-drawer-title');
  const shopAllBtn  = document.getElementById('nav-drawer-shop-all');
  const backBtn     = document.getElementById('nav-drawer-back');
  const l2List      = document.getElementById('nav-drawer-l2-list');
  const l2Promos    = document.getElementById('nav-drawer-l2-promos');
  const triggers    = document.querySelectorAll('[data-nav-drawer-trigger]');
  const closeBtn    = document.getElementById('nav-drawer-close');

  if (!drawer) return;

  // ─── Open drawer ─────────────────────────────
  function openDrawer(triggerEl) {
    lastTrigger = triggerEl || null;

    drawer.classList.add('is-open');
    drawer.removeAttribute('aria-hidden');
    overlay.classList.add('is-visible');

    // Force reflow so CSS transition fires
    overlay.offsetHeight;
    overlay.classList.add('is-active');

    document.body.style.overflow = 'hidden';

    // Update trigger aria state
    triggers.forEach(function (t) {
      t.setAttribute('aria-expanded', 'true');
    });

    // Focus close button after transition
    setTimeout(function () {
      if (closeBtn) closeBtn.focus();
    }, 50);

    // Attach focus trap
    drawer.addEventListener('keydown', trapFocus);
  }

  // ─── Close drawer ────────────────────────────
  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.classList.remove('is-active');
    document.body.style.overflow = '';

    // CRITICAL: Remove focus trap BEFORE returning focus
    drawer.removeEventListener('keydown', trapFocus);

    // Update trigger aria state
    triggers.forEach(function (t) {
      t.setAttribute('aria-expanded', 'false');
    });

    // Return focus to the trigger that opened the drawer
    // Use setTimeout to ensure drawer is fully out of the way
    setTimeout(function () {
      if (lastTrigger && document.contains(lastTrigger)) {
        lastTrigger.focus();
      }
      lastTrigger = null;
    }, 50);

    // Hide overlay after transition
    setTimeout(function () {
      overlay.classList.remove('is-visible');
    }, 280);

    // Reset to level 1 after transition completes
    setTimeout(resetToL1, 300);
  }

  // ─── Go to level 2 ───────────────────────────
  function openL2(title, url, items, promos) {
    currentLevel = 2;

    // Update header
    headerTitle.textContent = title;
    if (url && url !== '#') {
      shopAllBtn.href = url;
      shopAllBtn.style.display = 'inline-block';
    } else {
      shopAllBtn.style.display = 'none';
    }

    // Build level 2 list
    l2List.innerHTML = '';
    items.forEach(function (item) {
      const li = document.createElement('li');
      li.className = 'nav-drawer__item';
      const a = document.createElement('a');
      a.className = 'nav-drawer__link';
      a.href = item.url;
      a.textContent = item.title;
      li.appendChild(a);
      l2List.appendChild(li);
    });
    // Build promo tiles
    if (l2Promos) {
    l2Promos.innerHTML = '';
    (promos || []).forEach(function (promo) {
    if (!promo.image) return;
    const a = document.createElement('a');
    a.className = 'nav-drawer__promo-tile';
    a.href = promo.link;
    const img = document.createElement('img');
    img.src = promo.image;
    img.alt = promo.label || '';
    a.appendChild(img);
    if (promo.label) {
    const span = document.createElement('span');
    span.className = 'nav-drawer__promo-label';
    span.textContent = promo.label;
    a.appendChild(span);
    }
    l2Promos.appendChild(a);
    });
    }

    // Slide panels
    panelL1.classList.add('is-hidden');
    panelL2.classList.add('is-active');
    panelL2.scrollTop = 0;

    setTimeout(function () {
      if (backBtn) backBtn.focus();
    }, 230);
  }

  // ─── Back to level 1 ─────────────────────────
  function goBackToL1() {
    currentLevel = 1;
    headerTitle.textContent = 'Shop';
    shopAllBtn.style.display = 'none';
    panelL1.classList.remove('is-hidden');
    panelL2.classList.remove('is-active');
    panelL2.scrollTop = 0;
  }

  // ─── Reset to L1 ─────────────────────────────
  function resetToL1() {
    panelL1.classList.remove('is-hidden');
    panelL2.classList.remove('is-active');
    headerTitle.textContent = 'Shop';
    shopAllBtn.style.display = 'none';
    currentLevel = 1;
  }

  // ─── Focus trap ──────────────────────────────
  // Only active while drawer is open
  function trapFocus(e) {
    if (e.key === 'Escape') {
      closeDrawer();
      return;
    }

    if (e.key !== 'Tab') return;

    const focusable = Array.from(drawer.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(function (el) {
      return el.offsetParent !== null; // only visible elements
    });

    if (focusable.length === 0) return;

    const first = focusable[0];
    const last  = focusable[focusable.length - 1];

    if (e.shiftKey) {
      if (document.activeElement === first) {
        e.preventDefault();
        last.focus();
      }
    } else {
      if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  // ─── Event listeners ─────────────────────────

  // Open triggers
  triggers.forEach(function (trigger) {
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      openDrawer(this);
    });
  });

  // Close button
  if (closeBtn) {
    closeBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      closeDrawer();
    });
  }

  // Overlay click
  if (overlay) {
    overlay.addEventListener('click', function (e) {
      e.stopPropagation();
      closeDrawer();
    });
  }

  // Escape key (global — catches it even if focus is outside drawer)
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  // Back button
  if (backBtn) {
    backBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      goBackToL1();
    });
  }

  // Level 1 items with children
  if (panelL1) {
    panelL1.addEventListener('click', function (e) {
      const btn = e.target.closest('[data-nav-children]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();

      const title = btn.dataset.navTitle;
      const url   = btn.dataset.navUrl || '#';
      let items   = [];
      let promos  = [];

      try {
        items = JSON.parse(btn.dataset.navChildren);
      } catch (err) {
        console.warn('Nav drawer: could not parse children', err);
      }

      try {
      promos = JSON.parse(btn.dataset.navPromos);
      } catch (err) {
      console.warn('Nav drawer: could not parse promos', err);
      }

      openL2(title, url, items, promos);
    });
  }

  // Set initial aria state
  drawer.setAttribute('aria-hidden', 'true');
  triggers.forEach(function (t) {
    t.setAttribute('aria-expanded', 'false');
  });

})();